import { ICurrencyCode } from "../../components/SLCreate/SLCreateRequests";
import { getArrayFromCacheOrFromEndpoint } from "../../utilities/cacheValidator";
import { getCurrencyCodesFromEndpoint } from "./storeRequests";
import { APIAnomalyError } from "../../services/ErrorHelpers";
import { IUserProviderState } from "../UserContext";

export async function getCurrencyCodes(getTokenFn: IUserProviderState["accessToken"]): Promise<ICurrencyCode[]> {
  const currencyCodes = await getArrayFromCacheOrFromEndpoint<ICurrencyCode[]>(
    "CurrencyCodes",
    getCurrencyCodesFromEndpoint,
    getTokenFn
  );
  return currencyCodes;
}

export async function fetchAndParseCurrencyCodes(getTokenFn: IUserProviderState["accessToken"]): Promise<string[]> {
  const currencyCodeList = await getCurrencyCodes(getTokenFn);
  if (currencyCodeList.length === 0) {
    throw new APIAnomalyError("Received empty Array for Currency Codes");
  }
  return currencyCodeList.map((item) => String(item.code));
}
